import { join, map, split, trim } from 'lodash'

export default {
  methods: {
    getClientCountries (client) {
      return join(map(split(client.country_iso_3, ','), iso => this.translateIsoCountry(trim(iso))), ', ')
    },
    getClientImage (client) {
      try {
        return require(`@/assets/${client.id}.jpg`)
      } catch (_) {
        return require('@/assets/default.jpg')
      }
    },
    getFullUrl (page) {
      return window.location.origin + window.location.pathname + page.toString()
    },
    translateIsoCountry (iso) {
      return this.$te(`country.${iso}`) ? this.$t(`country.${iso}`) : iso
    }
  }
}
